import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09ad531a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-wrap" }
const _hoisted_2 = { class: "top-matadata" }
const _hoisted_3 = { class: "area-thumbnail" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "table matadata" }
const _hoisted_6 = { class: "area-pid" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "永続的識別子", -1))
const _hoisted_8 = { class: "area-title" }
const _hoisted_9 = { class: "area-author" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaceholderImage = _resolveComponent("PlaceholderImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.props.item.thumbnailValue)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: `data:image/jpeg;base64,${_ctx.props.item.thumbnailValue}`,
              alt: "サムネイル",
              height: "110"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createBlock(_component_PlaceholderImage, {
              key: 1,
              type: 'book-close'
            }))
      ]),
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("td", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.props.item.pid), 1)
            ])
          ]),
          _createElementVNode("tr", _hoisted_8, [
            _createElementVNode("th", null, _toDisplayString(_ctx.props.item.title.screenItemName), 1),
            _createElementVNode("td", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.props.item.title.value[0]), 1)
            ])
          ]),
          _createElementVNode("tr", _hoisted_9, [
            _createElementVNode("th", null, _toDisplayString(_ctx.props.item.author.screenItemName), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.props.item.author.value[0]), 1)
          ])
        ])
      ])
    ])
  ]))
}